import { render } from "./withMenuModel.vue?vue&type=template&id=894db8f8"
import script from "./withMenuModel.vue?vue&type=script&lang=js"
export * from "./withMenuModel.vue?vue&type=script&lang=js"

import "./withMenuModel.vue?vue&type=style&index=0&id=894db8f8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__